@if (visible) {
  <div class="sn-verify-banner" role="region" aria-label="Verify your email" data-test="verify-banner">
    <div class="sn-verify-icon" aria-hidden="true"><i class="fas fa-envelope-open-text"></i></div>
    <div class="sn-verify-body">
      <p class="sn-verify-title">Verify your email</p>
      <p class="sn-verify-text">
        We sent a link to <strong>{{ email || 'your email address' }}</strong>. You need it to invite teammates and
        export reports. Everything else works now.
      </p>
      <p class="sn-verify-status" aria-live="polite">
        @if (status === 'sent') {
          <span class="is-ok"><i class="fas fa-circle-check" aria-hidden="true"></i>Sent. Check your inbox.</span>
        } @else if (status === 'failed') {
          <span class="is-warning"><i class="fas fa-clock" aria-hidden="true"></i>We couldn't send it just now. Try again in a minute.</span>
        }
      </p>
    </div>
    <div class="sn-verify-actions">
      <button type="button" class="sn-verify-primary" [disabled]="status === 'checking'" (click)="checkAgain()">
        @if (status === 'checking') {
          <span class="spinner-border spinner-border-sm" aria-hidden="true"></span>
        }
        I've verified it
      </button>
      <button type="button" class="sn-verify-link" [disabled]="status === 'sending'" (click)="resend()">Resend email</button>
    </div>
    <button type="button" class="sn-verify-close" aria-label="Dismiss the email verification reminder" (click)="dismiss()">
      <i class="fas fa-xmark" aria-hidden="true"></i>
    </button>
  </div>
}
